import mqtt from "mqtt";

//const client = mqtt.connect("mqtt://broker.mqttdashboard.com:8000/mqtt");
//const client = mqtt.connect("mqtt://d681443fe4a743a89e51344735b18e28.s1.eu.hivemq.cloud:8883/mqtt");

//const client = mqtt.connect("mqtt://broker.emqx.io:8083/mqtt");
const client = mqtt.connect("wss://broker.emqx.io:8084/mqtt");

export default client;
